module.exports = __webpack_public_path__ + "static/04-065aab6b3146093e2926e511891a4aba.png";